export default function validate(values){
    const errors = {}
    if (!values.name)
      errors.name = 'Ingresa tu nombre'
    
    if (!values.lastName)
      errors.lastName = 'Ingresa tus apellidos'

    if (!values.phone)
      errors.phone = 'Escribe tu número de teléfono'

    if (!values.email)
      errors.email = 'Ingresa tu correo electrónico'
    else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email))
      errors.email = 'Ingresa un correo electrónico válido'

    if(!values.address)
        errors.address = 'Escribe la dirección donde recibirás tus servicios'

    if (!values.country)
      errors.country = 'Selecciona tu país de residencia'

    return errors
}